import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { AdministrationEndpoints } from "@dmms/shared/data-access/administration/types/administration-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { IDicBase } from "@models/dictionary/dic-base";
import { Validators } from "@angular/forms";

export class SettingGroupConfig implements IBaseConfig {
  version = 1;
  dicType = AdministrationEndpoints.SettingGroup;
  title = "settingGroups";

  fields: IHardFormField[] = [
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.EN, LangEnum.KZ],
        ),
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IDicBase[]> = {
    showDefaultActions: true,
    tableColumns: "40px 1fr 1fr auto",
    columns: [
      {
        name: "index",
        title: "#",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        name: "code",
        title: "dicTable.code",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        name: "name",
        title: "dicTable.name",
        type: HardTableColumnTypeEnum.Translate,
      },
    ],
  };
}
